import { Component, Input, OnInit } from '@angular/core';
import System from 'framework/System';

@Component({
	selector: 'app-components-managecustomer-connecteduserssidepanel',
	templateUrl: './ConnectedUsersSidePanel.component.html'
})
export class ConnectedUsersSidePanelComponent implements OnInit {
    public numberOfConnectedUsers = 0;

    protected floatPanel: IJQueryFloatPanel;
    @Input() customerId: number;

    ngOnInit() {
        this.floatPanel = ($('#connected-users-float-panel-mc') as any).floatPanel({ collapsed: true });
    }

    public onChanged(users: string[]): void {
        this.numberOfConnectedUsers = users.length;
    }
}
